import { forwardRef, createElement } from 'react';
import { Box, FormControl, FormLabel, FormErrorMessage } from '@chakra-ui/react';
import ReactQuill, { Quill } from 'react-quill';
import ImageResize from 'quill-image-resize-module-react';
import 'react-quill/dist/quill.snow.css';
import ImageCompress from 'quill-image-compress';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var toolbarTypes = {
  text: ['bold', 'italic', 'underline', 'strike', 'blockquote'],
  list: [{
    list: 'ordered'
  }, {
    list: 'bullet'
  }, {
    indent: '-1'
  }, {
    indent: '+1'
  }],
  image: ['image']
};

var getToolbar = function getToolbar(showTextToolbar, showListToolbar, showImageToolbar) {
  var toolbar = [];

  if (showTextToolbar) {
    toolbar.push(toolbarTypes.text);
  }

  if (showListToolbar) {
    toolbar.push(toolbarTypes.list);
  }

  if (showImageToolbar) {
    toolbar.push(toolbarTypes.image);
  }

  return toolbar;
};

var styles = {
  defaultSizes: {
    width: '400px',
    height: '200px'
  },
  fontSizes: {
    label: '13px',
    errorMessage: '13px'
  },
  colors: {
    red: '#e85858',
    gray: '#dedede',
    lightGray: '#ebecec'
  },
  borderRadius: '15px'
};
var _excluded = ["value", "label", "placeholder", "height", "width", "isInvalid", "error", "showTextToolbar", "showListToolbar", "showImageToolbar"];
Quill.register('modules/imageResize', ImageResize);
Quill.register("modules/imageCompress", ImageCompress);
var Editor = /*#__PURE__*/forwardRef(function (props, ref) {
  var value = props.value,
      label = props.label,
      placeholder = props.placeholder,
      height = props.height,
      width = props.width,
      _props$isInvalid = props.isInvalid,
      isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid,
      error = props.error,
      _props$showTextToolba = props.showTextToolbar,
      showTextToolbar = _props$showTextToolba === void 0 ? true : _props$showTextToolba,
      _props$showListToolba = props.showListToolbar,
      showListToolbar = _props$showListToolba === void 0 ? true : _props$showListToolba,
      _props$showImageToolb = props.showImageToolbar,
      showImageToolbar = _props$showImageToolb === void 0 ? true : _props$showImageToolb,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var showError = function showError() {
    return createElement(FormErrorMessage, {
      fontSize: styles.fontSizes.label,
      paddingTop: "5px"
    }, error);
  };

  return createElement(Box, {
    sx: {
      '& .quill': {
        width: width ? width : styles.defaultSizes.width
      },
      '& .ql-toolbar': _extends({
        borderRadius: styles.borderRadius + " " + styles.borderRadius + " 0 0",
        backgroundColor: styles.colors.lightGray,
        borderColor: styles.colors.gray
      }, isInvalid && {
        borderColor: styles.colors.red
      }),
      '& .ql-container': _extends({
        borderRadius: "0 0 " + styles.borderRadius + " " + styles.borderRadius,
        height: height ? height : styles.defaultSizes.height,
        borderColor: styles.colors.gray
      }, isInvalid && {
        borderColor: styles.colors.red
      })
    }
  }, createElement(FormControl, {
    isInvalid: isInvalid
  }, createElement(FormLabel, {
    fontSize: styles.fontSizes.label,
    whiteSpace: "nowrap"
  }, label), createElement(ReactQuill, Object.assign({
    modules: {
      toolbar: getToolbar(showTextToolbar, showListToolbar, showImageToolbar),
      imageResize: {
        parchment: Quill["import"]('parchment'),
        modules: ['Resize', 'DisplaySize']
      },
      imageCompress: {
        quality: 0.7,
        maxWidth: 1000,
        maxHeight: 1000,
        imageType: 'image/jpeg',
        debug: true,
        suppressErrorLogging: false
      }
    },
    placeholder: placeholder || '',
    value: value,
    theme: "snow",
    ref: ref
  }, rest)), isInvalid && showError()));
});
export default Editor;